// 응답 헤더 수신까지만 타임아웃을 적용. body 수신은 대역폭에 맡긴다.
export async function fetchWithConnectTimeout(
  url: string,
  connectTimeoutMs: number
): Promise<ArrayBuffer> {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), connectTimeoutMs);
  const tryFetch = async () => {
    try {
      return await fetch(url, { signal: controller.signal });
    } finally {
      clearTimeout(timeoutId);
    }
  };

  const res = await tryFetch();

  if (!res.ok) {
    throw new Error(`fetch failed: ${res.status} ${res.statusText}`);
  }
  return res.arrayBuffer();
}
